import { useState, useEffect } from "react";
import { useApiCall } from "./useApiCall";

export const useReviews = (productId) => {
  const [reviews, setReviews] = useState([]);
  const [reviewsError, setReviewsError] = useState();
  const [reviewsNumPages, setReviewsNumPages] = useState(1);
  const [reviewsStatus, setReviewsStatus] = useState("idle");

  const { executeApiCall, apiCallResponse, apiCallStatus } = useApiCall();

  const fetchReviews = (page, filters) => {
    let url = `/reviews/${productId}`;

    if (page) {
      url = url + `?page=${page}`;
    }

    if (filters) {
      filters = typeof filters === "object" ? JSON.stringify(filters) : filters;

      url = url + `${page ? `&filters=${filters}` : `?filters=${filters}`}`;
    }

    const requestOptions = {
      url,
    };

    executeApiCall(requestOptions);

    setReviewsStatus("pending");
  };

  useEffect(() => {
    switch (apiCallStatus) {
      case "success":
        if (apiCallResponse.data.data) {
          const { reviews, numPages } = apiCallResponse.data.data;

          setReviews(reviews);
          setReviewsNumPages(numPages);
          setReviewsStatus("ready");
        } else {
          setReviewsError(apiCallResponse.data.error.userMessage);
          setReviewsStatus("ready");
        }
        break;
      case "error":
        setReviewsStatus("ready");
        break;
    }
  }, [apiCallStatus, apiCallResponse]);

  return {
    reviews,
    reviewsNumPages,
    reviewsError,
    reviewsStatus,
    fetchReviews,
  };
};
